// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3273":"2efe703d33f27528","7578":"4d07b9f5646e3429"}[chunkId] + ".css";
};